import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.loanOfficerStatesPath();

    return FetchHelpers.get(url, { status: params });
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/StatesRepository.js